import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { saveDownloadedFile, type DownloadedFile } from '@/api/fileDownload';
import { downloadClientDataExport, downloadOwnDataExport } from '@/api/clients/clientDataExportApi';

export function useDownloadClientDataExportMutation(): UseMutationResult<
  DownloadedFile,
  Error,
  string
> {
  return useMutation({ mutationFn: downloadClientDataExport, onSuccess: saveDownloadedFile });
}

export function useDownloadOwnDataExportMutation(): UseMutationResult<DownloadedFile, Error, void> {
  return useMutation({ mutationFn: downloadOwnDataExport, onSuccess: saveDownloadedFile });
}
